import applicationGraphs from '@/utils/templates/logTemplates/application.graphs.config';

const log = {
  application: [applicationGraphs().barCharts],
};
export default log;
